// CHECKSUM:LsUgdqTZgXA9fcVrNx/GPg==
/*
 * This file was autogenerated by the TypeScriptApiGenerator.
 * Generated for Matrix.Licensor.Shared.Web.Commands.AddressSuggestionsCommand
 * Do not modify this file by hand.
 */

import { buildCommandRequest } from "shared/Components/Utils/buildCommandRequest";
import { ApiRequest } from "spry-react/utils/apiClient";
import { AddressSuggestionRequest } from "./AddressSuggestionRequest";
import { AddressSuggestionsResponse } from "./AddressSuggestionsResponse";

export namespace AddressSuggestionsCommand {
  export function load(request: AddressSuggestionRequest): ApiRequest<AddressSuggestionsResponse> {
    return buildCommandRequest('AddressSuggestions', 'LOAD', request);
  }
}
